import { Box } from "@mui/material";
import React from "react";
import classess from "./Style.module.css";

const Possessivartikel3 = () => {
  const Title = [
    "ضمیر فاعلی",
    "مذکر - DEM",
    "مونث - DER",
    "خنثی - DEM",
    "جمع - DEN+N",
  ];
  const ST1 = ["ICH", "meinem", "meiner", "meinem", "meinen"];
  const ST2 = ["DU", "deinem", "deiner", "deinem", "deinen"];
  const ST3 = ["ER", "seinem", "seiner", "seinem", "seinen"];
  const ST4 = ["SIE او", "ihrem", "ihrer", "ihrem", "ihren"];
  const ST5 = ["ES", "seinem", "seiner", "seinem", "seinen"];
  const ST6 = ["WIR", "unserem", "unserer", "unserem", "unseren"];
  const ST7 = ["IHR شما - غیر رسمی", "eurem", "eurer", "eurem", "euren"];
  const ST8 = ["SIE آنها", "ihrem", "ihrer", "ihrem", "ihren"];
  const ST9 = ["Sie شما - محترمانه", "Ihrem", "Irer", "Ihrem", "Ihren"];
  return (
    <Box className={classess.Wrapper}>
      <span>۳. ضمایر ملکی در حالت مفعولی غیرمستقیم (Dativ)</span>
      <Box className={classess.WP}>
        {Title.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                backgroundColor: "rgba(150, 150, 150, 0.1)",
                fontSize: "0.9rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST1.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                fontSize: index === 4 ? "0.75rem" : "1.1rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST2.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                fontSize: index === 4 ? "0.75rem" : "1.1rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST3.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                fontSize: index === 4 ? "0.75rem" : "1.1rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST4.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                fontSize: index === 4 ? "0.75rem" : "1.1rem",
              }}
            >
              {index === 4 ? (
                opt
              ) : (
                <abbr
                  title={
                    index === 3
                      ? "IIGHEM"
                      : index === 2
                      ? "IGHA"
                      : index === 1
                      ? "IIGHEM"
                      : "IIGHEN"
                  }
                >
                  {opt}
                </abbr>
              )}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST5.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                fontSize: index === 4 ? "0.75rem" : "1.1rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST6.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                fontSize: index === 4 ? "0.75rem" : "1.1rem",
                cursor: index === 4 ? null : "pointer",
              }}
            >
              {index === 4 ? (
                opt
              ) : (
                <abbr
                  title={
                    index === 1 || index === 3
                      ? "ONZEGHEM"
                      : index === 0
                      ? "ONZEGHEN"
                      : "ONZA"
                  }
                >
                  {opt}
                </abbr>
              )}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST7.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                fontSize: index === 4 ? "0.75rem" : "1.1rem",
                cursor: index === 4 ? null : "pointer",
              }}
            >
              {index === 4 ? (
                opt
              ) : (
                <abbr
                  title={
                    index === 1 || index === 3
                      ? "AIGHEM"
                      : index === 0
                      ? "AIGHEN"
                      : "AIGHA"
                  }
                >
                  {opt}
                </abbr>
              )}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST8.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                fontSize: index === 4 ? "0.75rem" : "1.1rem",
              }}
            >
              {index === 4 ? (
                opt
              ) : (
                <abbr
                  title={
                    index === 3
                      ? "IIGHEM"
                      : index === 2
                      ? "IGHA"
                      : index === 1
                      ? "IIGHEM"
                      : "IIGHEN"
                  }
                >
                  {opt}
                </abbr>
              )}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST9.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "64px",
                fontSize: index === 4 ? "0.75rem" : "1.1rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.Footers}>
        <span>
          Dativ : „{" "}
          <label className={classess.Label}>Ich helfe meinem Bruder.</label>“
        </span>
        <span className={classess.Span}>( من به برادرم کمک میکنم )</span>
        <span style={{ marginTop: "8px" }}>
          Dativ : „{" "}
          <label className={classess.Label}>
            Ich gebe meiner Mutter ein Geschenk.
          </label>
          “
        </span>
        <span className={classess.Span}>( من به مادرم یک هدیه میدهم )</span>
        <span style={{ marginTop: "8px" }}>
          Dativ : „{" "}
          <label className={classess.Label}>Ich spiele mit meinem Hund.</label>“
        </span>
        <span className={classess.Span}>( من کتابم را پیدا میکنم )</span>
        <span style={{ marginTop: "8px" }}>
          Dativ : „{" "}
          <label className={classess.Label}>
            Ich spreche mit meinen Eltern.
          </label>
          “
        </span>
        <span className={classess.Span}>( من با والدینم صحبت میکنم )</span>
      </Box>
    </Box>
  );
};

export default Possessivartikel3;
